import _extends from "@babel/runtime/helpers/esm/extends";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp;

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import invariant from 'invariant';
import { isKeyArrowDown, isKeyArrowUp, isKeyArrowVertical, isKeyEnter, isKeyEscape, isKeySpace } from "../../../lib/events/keyboard/identifiers";
import { locale } from "../../../lib/locale/decorators";
import { reactGetTextContent } from "../../../lib/reactGetTextContent";
import { Button } from "../../Button";
import { DropdownContainer } from "../../../internal/DropdownContainer";
import { filterProps } from "../../../lib/filterProps";
import { Input } from "../../Input";
import { Menu } from "../../../internal/Menu";
import { MenuItem } from "../../MenuItem";
import { MenuSeparator } from "../../MenuSeparator";
import { RenderLayer } from "../../../internal/RenderLayer";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { isFunction } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { ArrowChevronDownIcon } from "../../../internal/icons/16px";
import { cx } from "../../../lib/theming/Emotion";
import { Item } from "../Item";
import { SelectLocaleHelper } from "../locale";
import { styles } from "../Select.styles";
import { getSelectTheme } from "../selectTheme";
var PASS_BUTTON_PROPS = {
  disabled: true,
  error: true,
  use: true,
  size: true,
  warning: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseOver: true
};
export var Select = (_dec = locale('Select', SelectLocaleHelper), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      opened: false,
      value: _this.props.defaultValue,
      searchPattern: ''
    };
    _this.theme = void 0;
    _this.locale = void 0;
    _this.menu = void 0;
    _this.buttonElement = null;
    _this.getProps = createPropsGetter(Select.defaultProps);

    _this.open = function () {
      if (!_this.state.opened) {
        _this.setState({
          opened: true
        });

        if (_this.props.onOpen) {
          _this.props.onOpen();
        }
      }
    };

    _this.close = function () {
      if (_this.state.opened) {
        _this.setState({
          opened: false,
          searchPattern: ''
        });

        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    };

    _this.focus = function () {
      if (_this.buttonElement && _this.buttonElement.focus) {
        _this.buttonElement.focus();
      }
    };

    _this.dropdownContainerGetParent = function () {
      return ReactDOM.findDOMNode(_assertThisInitialized(_this));
    };

    _this.focusInput = function (input) {
      // fix cases when an Input is rendered in portal
      setTimeout(function () {
        return input == null ? void 0 : input.focus();
      }, 0);
    };

    _this.refMenu = function (menu) {
      _this.menu = menu;
    };

    _this.toggle = function () {
      if (_this.state.opened) {
        _this.close();
      } else {
        _this.open();
      }
    };

    _this.handleKey = function (e) {
      if (!_this.state.opened) {
        if (isKeySpace(e) || isKeyArrowVertical(e)) {
          e.preventDefault();

          _this.open();
        }
      } else {
        switch (true) {
          case isKeyEscape(e):
            _this.focus();

            _this.close();

            break;

          case isKeyArrowUp(e):
            e.preventDefault();

            if (_this.menu) {
              _this.menu.up();
            }

            break;

          case isKeyArrowDown(e):
            e.preventDefault();

            if (_this.menu) {
              _this.menu.down();
            }

            break;

          case isKeyEnter(e):
            e.preventDefault(); // To prevent form submission.

            if (_this.menu) {
              _this.menu.enter(e);
            }

            break;
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleSearch = function (value) {
      var _this$menu;

      _this.setState({
        searchPattern: value
      });

      (_this$menu = _this.menu) == null ? void 0 : _this$menu.highlightItem(1);
    };

    _this.buttonRef = function (element) {
      _this.buttonElement = element;
    };

    _this.getButton = function (buttonParams) {
      var button = _this.props._renderButton ? _this.props._renderButton(buttonParams) : _this.renderDefaultButton(buttonParams);
      var buttonElement = React.Children.only(button);
      return /*#__PURE__*/React.isValidElement(buttonElement) ? /*#__PURE__*/React.cloneElement(buttonElement, {
        ref: _this.buttonRef,
        onFocus: _this.props.onFocus,
        onBlur: _this.props.onBlur
      }) : buttonElement;
    };

    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
    if (!prevState.opened && this.state.opened) {
      window.addEventListener('popstate', this.close);
    }

    if (prevState.opened && !this.state.opened) {
      window.removeEventListener('popstate', this.close);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: getSelectTheme(theme, _this2.props)
      }, _this2.renderMain());
    });
  }
  /**
  * @public
  */
  ;

  _proto.renderMain = function renderMain() {
    var _this$renderLabel = this.renderLabel(),
        label = _this$renderLabel.label,
        isPlaceholder = _this$renderLabel.isPlaceholder;

    var buttonParams = {
      opened: this.state.opened,
      label: label,
      isPlaceholder: isPlaceholder,
      onClick: this.toggle,
      onKeyDown: this.handleKey
    };
    var style = {
      width: this.props.width,
      maxWidth: this.props.maxWidth || undefined
    };
    var button = this.getButton(buttonParams);
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(RenderLayer, {
      onClickOutside: this.close,
      onFocusOutside: this.close,
      active: this.state.opened
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.root(),
      style: style
    }, button, !this.props.disabled && this.state.opened && this.renderMenu())));
  };

  _proto.renderLabel = function renderLabel() {
    var value = this.getValue();
    var item = this.getItemByValue(value);

    if (item != null || value != null) {
      return {
        label: this.getProps().renderValue(value, item),
        isPlaceholder: false
      };
    }

    return {
      label: /*#__PURE__*/React.createElement("span", null, this.props.placeholder || this.locale.placeholder),
      isPlaceholder: true
    };
  };

  _proto.getLeftIconClass = function getLeftIconClass(size) {
    if (this.props.use === 'link') {
      return styles.leftIconLink(this.theme);
    }

    switch (size) {
      case 'large':
        return styles.leftIconLarge(this.theme);

      case 'medium':
        return styles.leftIconMedium(this.theme);

      case 'small':
      default:
        return styles.leftIconSmall(this.theme);
    }
  };

  _proto.renderDefaultButton = function renderDefaultButton(params) {
    var _cx, _cx2;

    var buttonProps = _extends({}, filterProps(this.props, PASS_BUTTON_PROPS), {
      align: 'left',
      disabled: this.props.disabled,
      width: '100%',
      onClick: params.onClick,
      onKeyDown: params.onKeyDown,
      active: params.opened
    });

    var labelProps = {
      className: cx((_cx = {}, _cx[styles.label()] = this.props.use !== 'link', _cx[styles.placeholder(this.theme)] = params.isPlaceholder, _cx[styles.customUsePlaceholder()] = params.isPlaceholder && this.props.use !== 'default', _cx[styles.placeholderDisabled(this.theme)] = params.isPlaceholder && this.props.disabled, _cx)),
      style: {
        paddingRight: this.getSelectIconGap()
      }
    };
    var useIsCustom = this.props.use !== 'default';
    return /*#__PURE__*/React.createElement(Button, buttonProps, /*#__PURE__*/React.createElement("div", {
      className: styles.selectButtonContainer()
    }, this.props._icon && /*#__PURE__*/React.createElement("div", {
      className: this.getLeftIconClass(this.props.size)
    }, this.props._icon), /*#__PURE__*/React.createElement("span", labelProps, params.label), /*#__PURE__*/React.createElement("div", {
      className: cx(styles.arrowWrap(this.theme), (_cx2 = {}, _cx2[styles.arrowDisabled(this.theme)] = this.props.disabled, _cx2[styles.customUseArrow()] = useIsCustom, _cx2))
    }, /*#__PURE__*/React.createElement(ArrowChevronDownIcon, null))));
  };

  _proto.getSelectIconGap = function getSelectIconGap() {
    var _this3 = this;

    var getArrowPadding = function getArrowPadding() {
      switch (_this3.props.size) {
        case 'large':
          return _this3.theme.selectIconGapLarge;

        case 'medium':
          return _this3.theme.selectIconGapMedium;

        case 'small':
        default:
          return _this3.theme.selectIconGapSmall;
      }
    };

    var arrowLeftPadding = parseFloat(getArrowPadding()) || 0;
    return arrowLeftPadding;
  };

  _proto.renderMenu = function renderMenu() {
    var _this4 = this;

    var search = this.props.search ? /*#__PURE__*/React.createElement("div", {
      className: styles.search(),
      onKeyDown: this.handleKey
    }, /*#__PURE__*/React.createElement(Input, {
      ref: this.focusInput,
      onValueChange: this.handleSearch,
      width: "100%"
    })) : null;
    var value = this.getValue();
    return /*#__PURE__*/React.createElement(DropdownContainer, {
      getParent: this.dropdownContainerGetParent,
      offsetY: -1,
      align: this.props.menuAlign,
      disablePortal: this.props.disablePortal
    }, /*#__PURE__*/React.createElement(Menu, {
      ref: this.refMenu,
      width: this.props.menuWidth,
      onItemClick: this.close,
      maxHeight: this.props.maxMenuHeight
    }, search, this.mapItems(function (iValue, item, i, comment) {
      if (isFunction(item)) {
        var element = item();

        if ( /*#__PURE__*/React.isValidElement(element)) {
          return /*#__PURE__*/React.cloneElement(element, {
            key: i
          });
        }

        return null;
      }

      if ( /*#__PURE__*/React.isValidElement(item)) {
        return /*#__PURE__*/React.cloneElement(item, {
          key: i
        });
      }

      return /*#__PURE__*/React.createElement(MenuItem, {
        key: i,
        state: _this4.getProps().areValuesEqual(iValue, value) ? 'selected' : null,
        onClick: _this4.select.bind(_this4, iValue),
        comment: comment
      }, _this4.getProps().renderItem(iValue, item));
    })));
  };

  _proto.select = function select(value) {
    this.focus();
    this.setState({
      opened: false,
      value: value
    });

    if (this.props.onValueChange && !this.getProps().areValuesEqual(this.getValue(), value)) {
      this.props.onValueChange(value);
    }
  };

  _proto.getValue = function getValue() {
    if (this.props.value !== undefined) {
      return this.props.value;
    }

    return this.state.value;
  };

  _proto.mapItems = function mapItems(fn) {
    var items = this.props.items;

    if (!items) {
      return [];
    }

    var pattern = this.state.searchPattern && this.state.searchPattern.toLowerCase();
    var result = [];
    var index = 0;

    for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
      var entry = _step.value;

      var _normalizeEntry = normalizeEntry(entry),
          _value = _normalizeEntry[0],
          _item = _normalizeEntry[1],
          _comment = _normalizeEntry[2];

      if (!pattern || this.getProps().filterItem(_value, _item, pattern)) {
        result.push(fn(_value, _item, index, _comment));
        ++index;
      }
    }

    return result;
  };

  _proto.getItemByValue = function getItemByValue(value) {
    if (value === null || value === undefined) {
      return null;
    }

    var items = this.props.items || [];

    for (var _iterator2 = _createForOfIteratorHelperLoose(items), _step2; !(_step2 = _iterator2()).done;) {
      var entry = _step2.value;

      var _normalizeEntry2 = normalizeEntry(entry),
          itemValue = _normalizeEntry2[0],
          _item2 = _normalizeEntry2[1];

      if (this.getProps().areValuesEqual(itemValue, value)) {
        return _item2;
      }
    }

    return null;
  };

  return Select;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Select', _class2.propTypes = {
  areValuesEqual: PropTypes.func,
  defaultValue: PropTypes.any,
  disablePortal: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  filterItem: PropTypes.func,
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  maxMenuHeight: PropTypes.number,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.node,
  renderItem: PropTypes.func,
  renderValue: PropTypes.func,
  search: PropTypes.bool,
  value: PropTypes.any,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onValueChange: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func,
  onKeyDown: PropTypes.func
}, _class2.defaultProps = {
  renderValue: renderValue,
  renderItem: renderItem,
  areValuesEqual: areValuesEqual,
  filterItem: filterItem,
  use: 'default'
}, _class2.Item = Item, _class2.SEP = function () {
  return /*#__PURE__*/React.createElement(MenuSeparator, null);
}, _class2["static"] = function (element) {
  invariant( /*#__PURE__*/React.isValidElement(element) || typeof element === 'function', 'Select.static(element) expects element to be a valid react element.');
  return element;
}, _temp)) || _class);

function renderValue(value, item) {
  return item;
}

function renderItem(value, item) {
  return item;
}

function areValuesEqual(value1, value2) {
  return value1 === value2;
}

function normalizeEntry(entry) {
  if (Array.isArray(entry)) {
    return entry;
  } else {
    return [entry, entry, undefined];
  }
}

function filterItem(value, item, pattern) {
  if (item === Select.SEP) {
    return false;
  }

  if ( /*#__PURE__*/React.isValidElement(item) || isFunction(item) && /*#__PURE__*/React.isValidElement(item = item())) {
    item = reactGetTextContent(item);
  }

  if (typeof item === 'number') {
    item = item.toString(10);
  }

  if (typeof item !== 'string') {
    return false;
  }

  return item.toLowerCase().indexOf(pattern) !== -1;
}